export default function AShoppingExperience({ children }) {
  return (
    <>
      <p>
        Go on a Friday Shopping! spree with SHOP. Visit the exhibition at Bugis Street and find
        coupons* to redeem items specially made available in collaboration with selected shops,
        ranging across T-shirts, food & drinks, souvenirs, and more. Getting lost in the maze of
        shops is part of this shopping experience!
      </p>
      <p>* while stocks last</p>
      {children}
    </>
  );
}
